import gql from 'graphql-tag';

const CREATE_TAX = gql`
  mutation($tax: TaxInput!) {
    createTax(tax: $tax) {
      taxId
      name
      rates {
        rateId
        name
        rateValue
      }
      integrated
    }
  }
`;

const UPDATE_TAX = gql`
  mutation($taxId: ID!, $tax: TaxInput!) {
    updateTax(tax: $tax, taxId: $taxId) {
      taxId
      name
      rates {
        rateId
        name
        rateValue
      }
      integrated
    }
  }
`;

const DELETE_TAX = gql`
  mutation($taxId: ID!) {
    deleteTax(taxId: $taxId)
  }
`;

export { CREATE_TAX, UPDATE_TAX, DELETE_TAX };
